module.exports = __webpack_public_path__ + "static/media/xhr.d45855b9.jpg";